var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 2.91602H5.83268C3.33268 2.91602 1.66602 4.16602 1.66602 7.08268V12.916C1.66602 15.8327 3.33268 17.0827 5.83268 17.0827H14.166C16.666 17.0827 18.3327 15.8327 18.3327 12.916V7.08268C18.3327 4.16602 16.666 2.91602 14.166 2.91602ZM14.5577 7.99102L11.9493 10.0743C11.3993 10.516 10.6993 10.7327 9.99935 10.7327C9.29935 10.7327 8.59102 10.516 8.04935 10.0743L5.44102 7.99102C5.17435 7.77435 5.13268 7.37435 5.34102 7.10768C5.55768 6.84102 5.94935 6.79102 6.21602 7.00768L8.82435 9.09102C9.45768 9.59935 10.5327 9.59935 11.166 9.09102L13.7743 7.00768C14.041 6.79102 14.441 6.83268 14.6493 7.10768C14.866 7.37435 14.8243 7.77435 14.5577 7.99102Z",
    fill: "#FFBE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeYellow);
export default __webpack_public_path__ + "static/media/envelope--yellow.12cd4eca83978c4c97545ef8266a52f3.svg";
export { ForwardRef as ReactComponent };